import config from '../../config';
import { getApiKeyClient } from '../client/http';

const {
  apiBaseUrl: { elements: baseUrl },
} = config;

const apiKeyClient = () => getApiKeyClient(baseUrl);

export const getGeneratedVideo = async (
  elementId: string,
  isPreview: boolean = false,
) => {
  try {
    const response = await apiKeyClient().get(
      `api/elements/video/${elementId}?isPreview=${isPreview}`,
      { responseType: 'blob' },
    );

    return response.data;
  } catch (err: any) {
    throw new Error(`Error getting generated video: ${err.message}`);
  }
};
